<template>
  <div v-if="allData.length" class="report-career report-fs" dir="rtl">
    <div style="margin-top: 200px;" v-if="pathLogo == m "></div>

    <div class="mlogo">
      <img  class="wlogo" :src="pathLogo" />
     </div>
    <header>
      <div class="md-layout-item md-size-100 mt-25">
        <h2 style="margin-bottom: 35px" class="text-center fs-head-co">
          {{ fullName }}
        </h2>
        <h3
          style="margin-top: 0px; font-weight: bold"
          class="text-center fs-head-co"
        >
          {{ shortName }}
        </h3>
        <h3 style="font-weight: bold" class="text-center fs-head">
          كشف بأسماء الموظفين المرشحين للترقية للدرجة {{ Grade }} و
          {{ AboveGrade }} الذين انهو الحد الأدنى في درجاتهم الوظيفية عن شهر
          {{ monthDate }}
        </h3>
        <div class="text-center" style="direction: ltr; display: flex"></div>
      </div>
    </header>
    <section style="margin: 155px 20px 0" class="table-header">
      <div class="first text-center">ر . م</div>
      <div class="second">
        <div class="one">
          <p>الرقم الوظيفي</p>
          <p class="name">الإسم</p>
          <p>الوضع الوظيفي</p>
          <p>تاريخ التوظيف</p>
          <p>المؤهل العلمي</p>
          <p>التخصص</p>
          <p>الدرجة الحالية</p>
          <p>تاريخ الحصول عليها</p>
          <p>شهر العلاوة</p>
          <p>الدرجة المرقة لها</p>
          <p>تاريخ استحقاقها</p>
          <div>
            <p>تقدير تقارير الكفاءة السنوية</p>
            <div>
              <p>{{  allData[0].numberOfTheYear }}</p>
              <p>{{  allData[0].numberOfTheYearTwo }}</p>
              <p>{{  allData[0].numberOfTheYearThree }}</p>

            
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      style="margin: 0px 20px"
      v-for="(item, i) in allData"
      :key="i"
      :class="{'custom-mt' : ( i+1 ) == 22}"
      class="table-body"
    >
      <p  :class="{'p-mt' : ( i) == 22}" class="index">{{ i + 1 }}</p>
      <div  :class="{'p-mt' : ( i ) == 22}" class="content">
        <p  :class="{'p-mt' : ( i ) == 22}"> {{ item.jobNumber }}</p>
        <p  :class="{'p-mt' : ( i ) == 22}" class="name">{{ item.employeeName }}</p>
        <p  :class="{'p-mt' : ( i ) == 22}">{{ item.jobType }}</p>
        <p :class="{'p-mt' : ( i) == 22}">{{ item.jobDate == null ? "" : convert(item.jobDate) }}</p>
        <p  :class="{'p-mt' : ( i ) == 22}">{{ item.scientificAppointment }}</p>
        <p :class="{'p-mt' : ( i) == 22}">{{ item.specialization }}</p>
        <p  :class="{'p-mt' : ( i ) == 22}">{{ item.currentGrade }}</p>
        <p :class="{'p-mt' : ( i) == 22}">
          {{
            item.lastGradeUpdate == null ? "" : convert(item.lastGradeUpdate)
          }}
        </p>
        <p :class="{'p-mt' : ( i ) == 22}">{{ item.monthName }}</p>
        <p :class="{'p-mt' : ( i ) == 22}">{{ item.dueGrade }}</p>
        <p :class="{'p-mt' : ( i ) == 22}">{{ item.monthDate == null ? "" : convertDay(item.monthDate) }}</p>
        <div>
          <p>{{ item.efficiency }}</p>
          <p>{{ item.efficiencyTwo }}</p>
          <p>{{ item.efficiencyThree }}</p>
        </div>
      </div>
    </section>

    

    <div class="md-layout mt-25 text-center last-footer">
      <div class="md-layout-item md-size-50">
        <p class="fs-head" style="font-weight: bold">إعداد</p>
        <p class="fs-head" style="font-weight: bold">رئيس قسم شؤون الموظفين</p>
      </div>

      <div class="md-layout-item md-size-50">
        <p class="fs-head" style="font-weight: bold">إعتماد</p>
        <p class="fs-head" style="font-weight: bold">
          مدير إدارة الشؤون اللإدارية
        </p>
      </div>
    </div>
  </div>
</template>

<script>
 import env from "../../../env";

export default {
  mounted() {},
  data() {
    return {
      m:env.mTop(),

    };
  },
  props: [
    "allData",
    "fullName",
    "shortName",
    "Grade",
    "AboveGrade",
    "monthDate",
    "pathLogo",
    "countE",
  ],

  methods: {
    convertDay(event) {
            try {
                let d = new Date(event);
                if (isNaN(d.getFullYear()) === true) {
                    return "-";
                }
                return (
                    d.getFullYear() + "-" + (d.getMonth() + 1) 

                    // +
                    // " , "
                    // +
                    // d.getHours() +
                    // ":" +
                    // d.getMinutes()
                );
            } catch (error) { }
        },
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getFullYear() + " - " + (d.getMonth() + 1) + " - " + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/career-promotion";

.report-fs {
  * {
    font-size: 18px !important;
    font-family: "Cairo", sans-serif !important;
  }
  .fs-head-co {
    font-size: 29px !important;
    font-weight: bold;
  }
  .fs-head {
    font-size: 25px !important;
  }
  .custom-mt {
    margin-bottom: 95px !important;
  }

  .p-mt  {
    border-top: 1px solid #000 !important;
  }
}
</style>
